<template>
  <!-- 选择 -->
  <div class="choice">
    <em class="audio-play"></em>
    <audio src="" class="cur-play-audio" ref="cur_play_audio"></audio>
    <div class="question-box">
      <div class="questions-content vertical-content">
        <img class="questions-bg" src="@/assets/images/studyCenter/questions/p-bg.png" alt />
        <div class="list">
          <div class="item cur" @click="changeType">
            fdafd
          </div>
          <div class="item">
            <img src="@/assets/images/studyCenter/questions/p-bg.png" alt />
          </div>
          <div class="item">
            <img src="@/assets/images/studyCenter/questions/p-bg.png" alt />
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>
<script>
export default {
  name: 'Choice',
  methods: {
    getData() {
      console.log("getData");
    },
    changeType () {
      this.$emit('changeType', 1)
    }
  }
}
</script>